import * as React from "react";
import moment from "moment";

export const CurrentPlan = (props) => {
    let { currentPlanEffectiveDate, dentalInvoice, invoiceDownloadFunction, payOnlineFunction } = props;
    let currentPlanEffective = currentPlanEffectiveDate ? moment(currentPlanEffectiveDate, "YYYY-MM-DD").format("L"): "";
    let memberSince = null; //**TO-DO**
    let contractNum = dentalInvoice.ContractNumber;

    return <div className="container-fluid hp">
        <div className="row">
            <div className="col-12 maxWidth-content">
                <div className="benefits-wrapper dental-wrapper">
                    <div className="benefits-container">
                        <div className="sub-header">
                            <div className="row current-plan-title">
                                <div>
                                    <span className="bold-text sub-header-label">Current Plan Effective: </span>
                                    {currentPlanEffective}
                                    <span>{memberSince ? ' (Member Since ' + memberSince + ')' : ''}</span>
                                </div>
                                <div className="push-right mobile-push-up">
                                    <span className="bold-text sub-header-label">Contract Number: </span>
                                    {contractNum}
                                </div>
                            </div>
                        </div>
                    </div>
                    {dentalPremium(dentalInvoice, invoiceDownloadFunction, payOnlineFunction)}
                </div>
            </div>
        </div>
    </div>;
}
const dentalPremium = (dentalInvoice, invoiceDownloadFunction, payOnlineFunction) => {
    let dueDate = dentalInvoice && dentalInvoice.DueDate ? moment(dentalInvoice.DueDate).format("MM/DD/YYYY") : "N/A";

    return <div className="row no-gutters dental-details-wrapper container"> {/*copays-container*/}
        <div className="dental-plan-details card row">
            <div className="container">
                <div className="row">
                    <div className="col"><strong>Dental Premium</strong></div>
                    <div className="col"> Due: <span>{dueDate}</span> </div>
                    <div className="col"> Amount: <span>${dentalInvoice && dentalInvoice.AmountDue ? dentalInvoice.AmountDue : "0.00"}</span></div>
                    <div className="col-1"></div>
                    <div className="col-4">
                        <span className="link-text cursor-pointer" onClick={() => invoiceDownloadFunction()}>Invoice Details</span>
                        /
                        <span className="link-text cursor-pointer" onClick={() => payOnlineFunction()}>Pay Online</span>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}

/***
 * 
 *
                                
                                
                                
                                */